
import useTreeNode from '@/composables/useTreeNode'
import { SelectOption } from '@/models/generics'
import { debounce } from '@/utils'
import _ from 'lodash'
import { defineComponent, ref, Ref, reactive, computed, ComputedRef, toRefs, PropType, watch } from 'vue'
import ObjectTreeNode from './ObjectTreeNode.vue'

export default defineComponent({
  name: 'NestedTreeNestedNode',
  components: { ObjectTreeNode },
  props: {
    modelValue: {
      type: [Object, Array] as PropType<Record<string, any> | Array<Record<string, any>>>,
      default: () => ({})
    },
    suggestions: {
      type: Array as PropType<Array<SelectOption>>,
      default: () => ([])
    },
    label: {
      type: String,
      default: 'Add Node'
    }
  },
  emits: ['update:modelValue', 'node:add', 'node:remove', 'input'],
  setup (props, actions) {
    const { state, ...nodeProps } = useTreeNode(props, actions)

    return {
      ...toRefs(state),
      ...nodeProps
    }
  }
})
